import { YEAR_FIRST_MONTH, YEAR_LAST_MONTH } from '../../../constants/date'
import { useDateLocale } from '../../../hooks'
import { MonthYearSelect } from '../MonthYearSelect'

import {
  getMonthSelectOption,
  getMonthSelectOptions,
} from './MonthSelect.utils'

import * as styles from './MonthSelect.module.css'

function MonthSelect({
  className = styles.MonthSelect,
  maxValue,
  minValue,
  value,
  onChange,
  ...selectProps
}) {
  const locale = useDateLocale()

  const minMonth = minValue ?? YEAR_FIRST_MONTH
  const maxMonth = maxValue ?? YEAR_LAST_MONTH

  const selectOptions = getMonthSelectOptions(locale, minMonth, maxMonth)

  const selectValue =
    selectOptions.find(option => option.value === value) ??
    getMonthSelectOption(value, locale)

  function handleSelectItem({ value }) {
    onChange?.(value)
  }

  return (
    <MonthYearSelect
      {...selectProps}
      className={className}
      options={selectOptions}
      value={selectValue}
      onSelectItem={handleSelectItem}
    />
  )
}

export default MonthSelect
